module.exports = __webpack_public_path__ + "static/example_4_day-5895f3a5c7d9a1def92b060bd0ea761f.png";